module.exports = __webpack_public_path__ + "static/media/Type_AC_ground_floor.d6404a14.jpg";